import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import reducers from './reducers';
import reduxThunk from 'redux-thunk';

let composeEnhancers = compose;
// eslint-disable-next-line no-mixed-operators
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionsBlacklist: ['ON_CHECKLIST_TIMER_CHANGE'],
    });

export default createStore(
    combineReducers({
        ...reducers,
    }),
    composeEnhancers(applyMiddleware(reduxThunk)),
);
